// extracted by mini-css-extract-plugin
module.exports = {"wrap":"goback_wrap__1eD3j","colorWrap":"goback_colorWrap__2sqlX","title":"goback_title__3bejz"};